export const SET_UNSAVED_CHANGES = 'SET_UNSAVED_CHANGES';
export const CLEAR_UNSAVED_CHANGES = 'CLEAR_UNSAVED_CHANGES';
